var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,18h8v-2h-8v2ZM8,14h8v-2h-8v2ZM6,22c-.6,0-1-.2-1.4-.6s-.6-.9-.6-1.4V4c0-.6.2-1,.6-1.4s.9-.6,1.4-.6h8l6,6v12c0,.6-.2,1-.6,1.4s-.9.6-1.4.6H6ZM13,9h5l-5-5v5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.2a9ab2d2f080d2dec3bcb06e165982e3.svg";
export { ForwardRef as ReactComponent };